export default "__VITE_ASSET__2VtbqvuX__"